import { apiClient } from './client';

export interface ExplorationShareInfo {
  id: string;
  exploration_id: string;
  shared_with_email: string;
  shared_with_display_name: string | null;
  permission: string;
  created_at: string;
}

export interface SharedExplorationItem {
  id: string;
  name: string;
  description: string | null;
  status: string;
  ontology_name: string | null;
  knowledge_base_name: string | null;
  owner_email: string;
  owner_display_name: string | null;
  shared_at: string;
}

/** Exploration (knowledge-graph) sharing endpoints. Mirrors shareApi. */
export const explorationShareApi = {
  shareExploration(explorationId: string, email: string): Promise<ExplorationShareInfo> {
    return apiClient.post(`/api/explorations/${explorationId}/shares`, { email });
  },
  getShares(explorationId: string): Promise<ExplorationShareInfo[]> {
    return apiClient.get(`/api/explorations/${explorationId}/shares`);
  },
  revokeShare(explorationId: string, shareId: string): Promise<void> {
    return apiClient.delete(`/api/explorations/${explorationId}/shares/${shareId}`);
  },
  getSharedWithMe(): Promise<SharedExplorationItem[]> {
    return apiClient.get('/api/explorations/shared-with-me');
  },
};

// Made with Bob
